import 'react';
import {
  arrayOf,
  bool,
  object,
  oneOf,
  oneOfType,
  shape,
  string,
  number,
} from 'prop-types';

export const Channel = {
  name: string.isRequired,
  value: string.isRequired,
};

export const Filter = {
  name: string.isRequired,
  text: string.isRequired,
  value: oneOfType([arrayOf(string), string, number]),
  selected: bool,
  exclusive: bool,
  basicFilter: bool,
  channel: string,
  channels: arrayOf(shape(Channel)),
};

export const FilterGroup = {
  groupName: string.isRequired,
  filterType: oneOf(['radio', 'checkbox']),
  filters: arrayOf(shape(Filter)).isRequired,
};

export const SearchOptions = {
  searchText: string,
  fromDate: oneOfType([string, object]),
  thruDate: oneOfType([string, object]),
  scope: shape(FilterGroup),
  packageType: shape(FilterGroup),
  field: shape(FilterGroup),
};

export default SearchOptions;
